
var url_domain = window.location.host;
var config_url = '';
if (url_domain.includes('localhost:80')) {
    //    config_url = 'http://127.0.0.1:3333/api/1.0';
    // config_url = 'https://apitest.chamirides.com/api/1.0';

    //config_url = 'https://apiinspectiontest.chamirides.com/api/1.0';
    config_url = 'https://apiinspection.chamirides.com/api/1.0';

} else if (url_domain == 'inspecciones.chamirides.com') {
    config_url = 'https://apiinspection.chamirides.com/api/1.0';
}
else if (url_domain == 'inspeccionestest.chamirides.com') {
    config_url = 'https://apiinspectiontest.chamirides.com/api/1.0';
}
console.log('Backend Conected: ' + config_url)
export const apiPath = config_url;


